import React from "react";
import { Route, Redirect } from "react-router-dom";

import useAuth from "../../../customHooks/useAuth";

const AdminProtectedRoute = ({ component: Component, ...rest }) => {
  const { loadingAuth, isAuth, rol } = useAuth();
  if (loadingAuth) {
    return <></>;
  }
  if (isAuth) {
    if (rol) {
      return (
        <Route
          {...rest}
          render={(props) =>
            rol === "admin" ? <Component {...props} /> : <Redirect to="/" />
          }
        />
      );
    }
  } else {
    return <Route {...rest} render={() => <Redirect to="/login" />} />;
  }
};

export default AdminProtectedRoute;
